// css =>
import "../../BaseStructure.css";
import Styled from "./mainPageMenuBar.module.css";

// react =>
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";

// componenets =>
import { useMessage } from "../../Contexts/MessageBoxContext";

// icons =>
import ProfileIcon from "../../Assets/Icons/profile.png";

// API =>
import backEnd from "../../services/Api";

// store =>
import { useUserStore } from "../../hooks/useUserStore";

function MainPageMenuBar(Props: {isAuthenticated: boolean}) {
    const navigate = useNavigate();
    const menuRef = useRef<HTMLDivElement | null>(null);

    const handleLogOut = async () => {
        useUserStore.getState().setUser(null);
        localStorage.removeItem("user-storage");

        const result = await backEnd.get("users/user-logout/", {
            withCredentials: true
        })

        document.location.reload();
    }

    return(
        <div className={`row ${ Styled.FirstMenuFrame } `}>
            <div className={`col-9 ${ Styled.RightFirstMenuFrame } `}>
                {
                    Props.isAuthenticated ? (
                        <div
                            className="col-2"
                            onMouseEnter={() => {
                                if (menuRef.current) {
                                    menuRef.current.style.display = 'inline-block';
                                }
                            }}
                            onMouseLeave={() => {
                                if (menuRef.current) {
                                    menuRef.current.style.display = 'none';
                                }
                            }}
                            onClick={() => {
                                if (menuRef.current && menuRef.current.style.display === "none") {
                                    menuRef.current.style.display = 'inline-block';
                                } else if (menuRef.current) {
                                    menuRef.current.style.display = 'none';
                                }
                            }}>
                            <img src={ ProfileIcon } alt="profile" />
                        </div>
                    ) : (
                        <div className="col-2" onClick={() => {
                            navigate("/log-in");
                        }}>
                            <p>ورود / ثبت نام</p>
                        </div>
                    )
                }

                <div className="col-2" onClick={() => {
                    navigate("/show-products");
                }}>
                    <p>محصولات</p>
                </div>
                <div className="col-2" onClick={() => {
                    alert("به زودی");
                    navigate("/");
                }}>
                    <p>گالری</p>
                </div>
                <div className="col-2" onClick={() => {
                    alert("به زودی");
                    navigate("");
                }}>
                    <p>تماس با ما</p>
                </div>
                <div className="col-2" onClick={() => {
                    alert("به زودی");
                    navigate("");
                }}>
                    <p>درباره ما</p>
                </div>
            </div>

            <div className={`col-4 ${ Styled.LeftFirstMenuFrame } `}>
                <h1>We Dook</h1>
            </div>

            <div className={ Styled.dropdown } ref={ menuRef } style={{ marginLeft: '26%', display: 'none' }} onMouseEnter={() => {
                if (menuRef.current) {
                    menuRef.current.style.display = 'inline-block';
                }
            }} onMouseLeave={() => {
                if (menuRef.current) {
                    menuRef.current.style.display = 'none';
                }
            }}>
                <div className={` row ${ Styled.menu } `}>
                    <div className={`col-1 ${ Styled.CheckBox } `}>
                        <div className="col-1"></div>
                    </div>
                    <div className={` col-8 ${ Styled.item } `} onClick={() => {
                        navigate("/edit-profile");
                    }}>
                        پروفایل من
                    </div>

                    <div className={`col-1 ${ Styled.CheckBox } `}>
                        <div className="col-1"></div>
                    </div>
                    <div className={` col-8 ${ Styled.item } `} onClick={() => {
                        navigate("/shopping-card");
                    }}>
                        سبد خرید
                    </div>

                    <div className={`col-1 ${ Styled.CheckBox } `}>
                        <div className="col-1"></div>
                    </div>
                    <div className={` col-8 ${ Styled.item } `} onClick={() => {
                        navigate("/show-products");
                    }}>
                        محصولات
                    </div>

                    <div className={`col-1 ${ Styled.CheckBox } `}>
                        <div className="col-1"></div>
                    </div>
                    <div className={` col-8 ${ Styled.item } `} onClick={ handleLogOut }>
                        خروج از حساب کاربری
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MainPageMenuBar;
